import React, { useState } from "react";
import { saveAs } from "file-saver"; // Install this library using `npm install file-saver`
import "./Pages.css";
import Breadcrumb from "./Breadcrumb";
import PodcastBox from "../Podcast/PodcastBox";
import PodcastBoxVideo from "../Podcast/PodcastBoxVideo";
import axios from "axios";
import PodcastsLoading from "../loading/podcasts";
import PodacastVideoBoxLoading from "../loading/podcast-video-box";
import { useLanguage } from "../../store/language-context";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

// Function to generate RSS XML
const generateAllRSS = (podcasts) => {
  return `<?xml version="1.0" encoding="UTF-8" ?>
<rss version="2.0">
  <channel>
    <title>All Podcasts</title>
    <link>#</link>
    <description>A collection of all podcasts</description>
    <language>en-us</language>
    ${podcasts
      .map(
        (podcast) => `
    <item>
      <title>${podcast.title}</title>
      <description>${podcast.description}</description>
      <link>${podcast.link || "#"}</link>
      <guid>${podcast.link || "#"}</guid>
      <pubDate>${new Date(podcast.date || Date.now()).toUTCString()}</pubDate>
      <enclosure url="${podcast.sound || ""}" type="audio/mpeg" />
      <image>${podcast.image || ""}</image>
    </item>
    `
      )
      .join("")}
  </channel>
</rss>`;
};

// Function to download RSS file
const downloadAllRSS = (podcasts) => {
  const rssContent = generateAllRSS(podcasts);
  const blob = new Blob([rssContent], { type: "application/rss+xml" });
  saveAs(blob, `All_Podcasts.rss`);
};

const Podcasts = () => {
  const { t } = useTranslation();
  const { URL } = useLanguage();
  const [idAndTitle, setIdAndTitle] = useState({
    id: 5,
    title: ''
  });

  // main podcasts (right side)
  const { data: mainPodcasts, error, isLoading } = useQuery({
    queryKey: ['main-podcasts', URL],
    queryFn: async () => {
      const response = await axios.get(`${URL}/category-podcasts`);
      if (response.status !== 200) throw new Error(t('custom.err'))
      return response.data?.data?.data ?? response.data?.data;
    },
    retry: 1,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  // epsisods of podcast (left side)
  const { data: episodsOfPodcast, error: eErr, isLoading: eLoad } = useQuery({
    queryKey: ['episods-podcasts', idAndTitle.id, URL],
    queryFn: async () => {
      const response = await axios.get(`${URL}/category-podcasts/${idAndTitle?.id}`);
      if (response.status !== 200) throw new Error(t('custom.err'))
      return response.data?.data?.data ?? response.data?.data;
    },
    retry: 1,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  // ضيف ال suspense في ال route (app.js) و شيل ال loading دي
  if (isLoading) return (
    <PodcastsLoading />
  );

  if (error) {
    <div className="h-dvh w-full flex justify-center items-center">
      <p>
        {error}
      </p>
    </div>
  };
  return (
    <>
      <Breadcrumb pages={[t('routes.podcasts')]} />
      <main className="container">
        <main className="grid grid-cols-[38%_58%] py-4 gap-7 max-lg:grid-cols-1 max-lg:gap-8">
          <section className="text-start">
            <section className="max-lg:relative max-lg:top-0">
              {
                mainPodcasts?.map((podcast) => (
                  <PodcastBox key={podcast?.id} seePodcasts={setIdAndTitle} podcast={podcast} rssFnc={() => downloadAllRSS(episodsOfPodcast?.podcasts)}>
                    {/* for responsive */}
                    {
                      episodsOfPodcast?.podcasts?.length > 0 ?
                        episodsOfPodcast?.podcasts?.map((podcast, i) => (
                          <div key={podcast?.id}>
                            <PodcastBoxVideo
                              podcast={podcast} presenter={idAndTitle?.title} />
                            {i !== episodsOfPodcast?.podcasts?.length - 1 ? <hr className="my-4" /> : null}
                          </div>
                        ))
                        :
                        eLoad && !eErr ? (
                          [...Array(2)].map((_, iLoad) => (
                            <PodacastVideoBoxLoading key={iLoad} />
                          ))
                        ) : (
                          <div className="text-start p-2">
                            <p>{t('custom.no-data')}</p>
                          </div>
                        )
                    }
                  </PodcastBox>
                ))
              }
            </section>
          </section>


          <section className="rounded-lg block max-lg:hidden overflow-y-scroll border p-6">
            {/* seen in a big screen */}
            {episodsOfPodcast?.podcasts?.length > 0 ? (
              episodsOfPodcast.podcasts.map((podcast, i) => (
                <div key={podcast?.id}>
                  <PodcastBoxVideo
                    podcast={podcast}
                    error={eErr}
                    isLoading={eLoad}
                    presenter={idAndTitle?.title}
                  />
                  {i !== episodsOfPodcast.podcasts.length - 1 && (
                    <hr className="my-4" />
                  )}
                </div>
              ))
            ) : eLoad && !eErr ? (
              [...Array(3)].map((_, iLoad) => (
                <PodacastVideoBoxLoading key={iLoad} />
              ))
            ) : (
              <div className="text-start p-2">
                <p>{t('custom.no-data')}</p>
              </div>
            )}
          </section>
        </main>
      </main>
    </>
  );
};

export default Podcasts;